import {
  Component,
  OnInit,
  ViewChild,
  ViewContainerRef,
  Inject,
} from "@angular/core";
import { Router } from "@angular/router";
import { fixedValues } from "src/app/shared/constants/fixed-values.enum";
import { LangService } from "src/app/core/services/lang.service";
import { UtilityService } from "src/app/shared/services/utility.service";
import { CompanyService } from "src/app/shared";
import { ModalService } from "src/app/shared/services/modal.service";
import { FormParam } from "src/app/features/in/models/form-param";
import { globalVariables } from "src/app/core/constants/globalVariables";
import { UserPrivileges } from "src/app/core/models/user-privileges";
import { WebStorageService } from "src/app/core/services/web-storage.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-submodule-menu",
  templateUrl: "./submodule-menu.component.html",
})
export class SubmoduleMenuComponent implements OnInit {
  psDateFormat: any;
  @ViewChild("modalContainer", { static: true, read: ViewContainerRef })
  container;
  public formParam: FormParam = new FormParam();
  //AG grid For Work Order List
  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "PurchaseReqGrid";
  gridVopt: any = {
    //
  };

  public userPrivilege = new UserPrivileges();

  public fixedValues = fixedValues;
  public numberPrecision;
  //public otherConditionListBacup = new Array<OthersCondition>();
  //public purContListBacup = new Array<OthersCondition>();

  public itemListBackup: any = [];
  public subModuleList: any = [];

  // @Input()
  data: any = {};

  // @Input()
  // modalShow: boolean = true;

  // @Input()
  // detailsObj;

  // @Output()
  // actionController$: EventEmitter<any> = new EventEmitter<any>();
  public rowSelection = "single";

  public modal: ModalService;

  companyList = [];
  selectedCompany = {};
  currentLanguageActive = globalVariables.currentLanguage;

  activeCompany;
  activeCompanyName: string;
  moduleList: any = [];

  constructor(
    private commonService: CompanyService,
    public langService: LangService,
    public utilityService: UtilityService,
    public router: Router,
    private storageService: WebStorageService,
    @Inject(MAT_DIALOG_DATA) data: any,
    private matDialogRef: MatDialogRef<any>
  ) {
    this.data = data;
  }

  ngOnInit() {
    // console.log("All Menues",this.storageService.getMenu('MENU_F'))

    const companyObj = this.commonService.getUserGlobalCompany();
    this.companyList = companyObj.companyList;
    this.activeCompany = globalVariables.userInfo.company_NO;
    this.activeCompanyName = globalVariables.userInfo.company_NAME;

    console.log(this.data.subModuleList);

    this.moduleList = this.data.subModuleList.map((element) => {
      if (element["MENU_ID"] === "ID") {
        element["MENU_ID"] = "GR";
      }

      if (element["CARD_VIEW_FLAG"] != null) {
        let allMenues = JSON.parse(
          JSON.stringify(this.storageService.getMenu("MENU_F"))
        );
        let subModule = allMenues.filter(
          (el) => el["PARENT_OBJ_NO"] == element["OBJ_NO"]
        );
        this.subModuleList = subModule;
      }

      return element;
    });

    // this.moduleList=this.storageService.getModule();

    console.log("this.moduleList", this.moduleList);
  }

  onClickMenuModule(event, item) {
    if (item.CARD_VIEW_FLAG) {
      event.preventDefault();
      this.openSubmodulesModals();
    } else if (item.APEX_FLAG) {
      window.open(item.C_URL, "_self");
    }

    this.matDialogRef.close();
  }

  openSubmodulesModals(): void {
    this.utilityService
      .openDialog(SubmoduleMenuComponent, "md", {
        title: "",

        gridId: "SubmodulesMenu",
        columnDefs: "",
        api: "",
        params: "",
      })
      .subscribe((modal: any) => {
        modal.closed = () => {};
        modal.success = (result) => {};
      });
  }

  onClickClose() {
    this.matDialogRef.close();
  }
}
